import { useState } from "react";
import MainDrawer from "../MainDrawer/MainDrawer";
import AppBarHeader from "./AppBarHeader/AppBarHeader";

const AppBar = (): JSX.Element => {
    const [drawerOpen, setDrawerOpen] = useState(false);

    function handleOpenDrawer() {
        setDrawerOpen(true);
    }

    function handleCloseDrawer() {
        setDrawerOpen(false);
    }

    return (
        <>
            <AppBarHeader onLeftClick={handleOpenDrawer} />
            <MainDrawer open={drawerOpen} onClose={handleCloseDrawer} />
        </>
    );
};

export default AppBar;
